import { APIS, UserRole } from "utils/constants";
import { axiosInstance } from "./index";
export type UserID = number;
export type BadgeTier = "starter" | "contributor" | "achiever" | "champion";

export interface ICurrentBadge {
  quarter: string;
  quarterPoints: number;
  tier: BadgeTier;
  nextTier: string | null;
  pointsToNextTier: number | null;
}

export interface IBadgeHistory {
  quarter: string;
  quarterPoints: number;
  tier: BadgeTier;
}

export interface ILifetimeLevel {
  level: number;
  plusCount: number;
  nextLevel: number | null;
  pointsToNext: number | null;
}

export type IUserResponse = {
  id: UserID;
  teamId: number;
  email: string;
  phone?: string;
  title?: string;
  firstName: string;
  lastName: string;
  displayName: string;
  image512: string;
  image48: string;
  plusCount: number;
  minusCount: number;
  score: number;
  memberId: number;
  externalTeamId: string;
  externalId: string;
  integrationType: string;
  role: UserRole;
  createdAt: number;
  canSignIn: boolean;
  currentBadge?: ICurrentBadge | null;
  badgeHistory?: IBadgeHistory[];
  lifetimeLevel?: ILifetimeLevel;
};

export const currentUser = async (): Promise<IUserResponse> => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/users/current")
      .then((res) => {
        const data = res.data;
        data.score = data.plusCount - data.minusCount;
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getUser = async (
  userId: string | number
): Promise<IUserResponse> => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(`/users/${userId}`)
      .then((res) => {
        const data = res.data;
        data.score = data.plusCount - data.minusCount;
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export type IUserRank = {
  rank: number;
};

export const getUserRank = async (
  startDate: number,
  endDate: number,
  userId: UserID
): Promise<IUserRank> => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(`/users/${userId}/rank`, {
        params: {
          startDate,
          endDate,
          userId
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export type IUserMonthsScore = {
  yearMonth: string;
  score: number;
  sentCount: number;
};
export const userMonthesScoresReport = async (
  userId: number,
  startDate: number,
  endDate: number
): Promise<IUserMonthsScore[]> => {
  return new Promise((resolve, reject) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    axiosInstance
      .get(`/users/${userId}/score`, {
        params: {
          startDate,
          endDate,
          timeZone
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const editMemberSigninAccess = async (value: {
  memberId: number;
  canSignIn: boolean;
}): Promise<any> => {
  const res = await axiosInstance.patch(
    `${APIS.MEMBERS.BASE}/${value.memberId}`,
    { canSignIn: value.canSignIn }
  );
  return res.data;
};
